import React from 'react';
import { Container } from './Container';
import { Eyebrow, Highlight, SectionTitle } from './SectionHeading';
export function GuaranteeSection() {
  return <section className="bg-cream py-14 sm:py-20 lg:py-24" data-id="element-52" data-mp="4x34jyua9nii">
      <Container data-id="element-53" data-mp="9tl5enmht1pk">
        <div className="mx-auto flex max-w-[960px] flex-col items-center gap-7 rounded-2xl border border-line bg-white px-5 py-8 text-center sm:gap-10 sm:p-12 md:flex-row md:text-left" data-id="element-54" data-mp="9t1mb3l3w79y">
          <div className="grid h-[136px] w-[136px] shrink-0 place-items-center rounded-full border-4 border-teal bg-teal-soft sm:h-[170px] sm:w-[170px]" data-id="element-55" data-mp="jrr30t19nlom">
            <div className="text-center" data-id="element-56" data-mp="sl48svkfihs4">
              <span className="block font-condensed text-[56px] font-extrabold leading-none text-teal sm:text-[72px]" data-id="element-57" data-mp="sm5m76ox3gd0">10</span>
              <span className="block text-[11px] font-bold uppercase tracking-[0.2em] text-navy" data-id="element-58" data-mp="xm1lismo6jm8">Days</span>
              <span className="mt-1 block text-[9px] font-bold uppercase tracking-[0.16em] text-muted" data-id="element-59" data-mp="12h78zvvq06cf">Money-back</span>
            </div>
          </div>
          <div data-id="element-60" data-mp="25syof3xrs2mi">
            <Eyebrow data-id="element-61" data-mp="25ti3mcw1ccwu">Our guarantee</Eyebrow>
            <SectionTitle data-id="element-62" data-mp="20t3vkuufp2yt">
              Review it for <Highlight data-id="element-63" data-mp="20s2k4p9iaegk">10 days</Highlight>
            </SectionTitle>
            <p className="mt-4 text-[15px] text-muted sm:mt-5 sm:text-lg" data-id="element-64" data-mp="1vt7qstdwx7i7">
              Review the materials after purchase. If the book isn’t right for you, request a refund within ten days through the
              support contact provided with your order.
            </p>
          </div>
        </div>
      </Container>
    </section>;
}